import { hasSlotContent as e } from "../../common/utils/index.js";
import { t } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import n from "../validation-messages/validation-messages.js";
import { InputGroupMixin as r } from "../../common/mixins/input-group.js";
import i from "../text/text.js";
import { createBlock as a, createCommentVNode as o, createElementBlock as s, createTextVNode as c, createVNode as l, mergeProps as u, openBlock as d, renderSlot as f, resolveComponent as p, toDisplayString as m, withCtx as h } from "vue";
//#region components/input_group/input_group.vue
var g = {
	compatConfig: { MODE: 3 },
	name: "DtInputGroup",
	components: {
		DtValidationMessages: n,
		DtText: i
	},
	mixins: [r],
	props: {
		dataQaGroup: {
			type: String,
			default: "input-group"
		},
		dataQaGroupLegend: {
			type: String,
			default: "input-group-legend"
		},
		dataQaGroupMessages: {
			type: String,
			default: "input-group-messages"
		}
	},
	data() {
		return {
			internalValue: this.value,
			hasSlotContent: e
		};
	},
	watch: {
		value(e) {
			this.internalValue = e;
		},
		internalValue: {
			immediate: !0,
			handler(e) {
				this.provideObj.value = e;
			}
		}
	},
	methods: { getMessageKey(e, t) {
		return `input-group-message-${e}-${t}-${this.id}`;
	} }
}, _ = ["data-qa"];
function v(e, t, n, r, i, g) {
	let v = p("dt-text"), y = p("dt-validation-messages");
	return d(), s("fieldset", {
		class: "d-input-group__fieldset",
		"data-qa": n.dataQaGroup
	}, [
		i.hasSlotContent(e.$slots.legend) || e.legend ? (d(), a(v, u({
			key: 0,
			kind: "label",
			as: "legend",
			tone: "secondary",
			class: ["d-input-group__legend-text", e.legendClass]
		}, e.legendChildProps, { "data-qa": n.dataQaGroupLegend }), {
			default: h(() => [f(e.$slots, "legend", {}, () => [c(m(e.legend), 1)])]),
			_: 3
		}, 16, ["class", "data-qa"])) : o("", !0),
		f(e.$slots, "default"),
		l(y, u({
			"validation-messages": e.formattedMessages,
			"show-messages": e.showMessages,
			class: e.messagesClass,
			"data-qa": n.dataQaGroupMessages
		}, e.messagesChildProps), null, 16, [
			"validation-messages",
			"show-messages",
			"class",
			"data-qa"
		])
	], 8, _);
}
var y = /* @__PURE__ */ t(g, [["render", v]]);
//#endregion
export { y as default };

//# sourceMappingURL=input-group.js.map